/**
 * Collects all iterations/executions of a step from the workflow log output data structure.
 * This is useful for steps that run inside loops - it will return all executions.
 *
 * @param {Array} data - The workflow log output data structure (output?.data)
 * @param {string} targetStepId - The stepId to find all iterations for
 * @returns {Array} - Array of all step executions with their response data
 */
const getAllStepIterations = (data, targetStepId) => {
  const results = [];

  const traverse = (steps) => {
    if (!Array.isArray(steps)) {
      return;
    }

    for (const step of steps) {
      if (step?.stepId === targetStepId && step?.response) {
        const responseData = step.response?.data;
        const dataArray = Array.isArray(responseData) ? responseData : responseData ? [responseData] : [];

        if (dataArray.length > 0) {
          results.push({
            stepId: step.stepId,
            response: step.response,
            request: step.request,
            data: dataArray
          });
        }
      }

      if (step?.children && Array.isArray(step.children)) {
        for (const childGroup of step.children) {
          traverse(childGroup);
        }
      }
    }
  };

  traverse(data);

  return results;
};

export default getAllStepIterations;
